import { createContext, useContext } from "react";

import type { OnboardingAnalyticsApi } from "./useOnboardingAnalytics";

const OnboardingAnalyticsContext = createContext<OnboardingAnalyticsApi | null>(null);

export function OnboardingAnalyticsProvider({
  value,
  children,
}: {
  value: OnboardingAnalyticsApi;
  children: React.ReactNode;
}) {
  return (
    <OnboardingAnalyticsContext.Provider value={value}>
      {children}
    </OnboardingAnalyticsContext.Provider>
  );
}

export function useOnboardingAnalyticsContext() {
  const context = useContext(OnboardingAnalyticsContext);
  if (!context) {
    throw new Error("useOnboardingAnalyticsContext must be used within OnboardingAnalyticsProvider");
  }
  return context;
}

/** Optional accessor for slide hooks that may run outside provider during tests. */
export function useOptionalOnboardingAnalytics() {
  return useContext(OnboardingAnalyticsContext);
}
